<template>
  <el-dialog
  :visible.sync="visible"
  width="700px"
  :close-on-click-modal="false"
  @open="openEvent"
  :title="news.title"
  :show-close="false"
  >
    <div class="tip-wrapper">
      <div class="content">
        <p  v-html="news.content"></p>
      </div>
      <el-checkbox v-model="checked"></el-checkbox>
      <el-button size="small" type="primary" style="margin-left: 10px;" :disabled="!checked" @click="closeModal">已知悉</el-button>
    </div>
    <!-- <div class="footer" slot="footer">
      <el-button type="primary" :disabled="!checked" @click="closeModal">关闭</el-button>
    </div> -->
  </el-dialog>
</template>
<script>
import { getNewsDetailApi, noticeModalApi } from '../../api/api'
export default {
  name: 'tip-modal',
  data() {
    return {
      news: '',
      title: '',
      checked: false
    }
  },
  props: ['visible'],
  methods: {
    async openEvent () {
      try {
        const res = await getNewsDetailApi({ id: 226, count: 1 })
        if (res.data.code === 0) {
          const { news } = res.data.data
          this.news = news
        }
      } catch (error) {
      }
    },
    async closeModal () {
      await noticeModalApi({ is_tip: this.checked ? 1 : 0 })
      this.$emit('update:visible', false)
    }
  }

}
</script>
<style lang="scss" scoped>
.el-dialog__wrapper {
  /deep/ .tip-wrapper {
    text-align: center;
    p {
      line-height: 2!important;
      span {
      font-size: 15px!important;
      }
    }
  }
  /deep/ .el-dialog__header {
    text-align: center;
  }


}
</style>


// WEBPACK FOOTER //
// src/components/index/TipModal.vue